/**
 * Layout das telas publicas: entrar, esqueci minha senha e nova senha.
 *
 * Sem shell e sem guarda, de proposito — sao exatamente as telas de quem **nao** esta
 * autenticado. O que elas compartilham e a moldura: o cartao centrado com o logo da Orvalho
 * sobre o fundo claro do prototipo.
 *
 * O logo aqui **nao** leva o filtro de inversao da sidebar: o PNG e escuro e o fundo e claro.
 */

import { Outlet, createRoute } from '@tanstack/react-router'

import logoDaOrvalho from '@/assets/orvalho-logo.png'
import { rotaRaiz } from './raiz'
import './entrar.css'

function LayoutPublico() {
  return (
    <div className="entrada">
      <div className="entrada__cartao">
        <img className="entrada__logo" src={logoDaOrvalho} alt="Orvalho do Sol" />
        <Outlet />
      </div>
    </div>
  )
}

export const rotaPublica = createRoute({
  getParentRoute: () => rotaRaiz,
  id: 'publico',
  component: LayoutPublico,
})
